exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.margin-button[data-v-77ba1795]{margin-top:25px\n}\n", "", {"version":3,"sources":["/builds/youx-group/sicarf/sicarf-parametrizavel/frontend/src/components/AppDadosGeraisOs.vue"],"names":[],"mappings":";AA2DA,gCACE,eAAgB;CACjB","file":"AppDadosGeraisOs.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.margin-button {\n  margin-top: 25px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-77ba1795","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/AppDadosGeraisOs.vue
// module id = SrST
// module chunks = 12